import { Card, CardContent,ExpansionPanel,ExpansionPanelSummary,ExpansionPanelDetails, FormControl, Icon, Typography, Grid } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import CustomCardSubHeading from 'components/CustomCardHeading/CustomCardSubHeading.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import NumberInput from 'components/Wrappers/materialUIWrappers/components/NumberInput';
import { percentage } from 'helpers/ValidationHelpers';
import React from 'react';
import { Field } from 'redux-form';
import { addMonths } from 'date-fns';
import CustomChipLeft from "components/CustomChip/CustomChipLeft.jsx";
import CustomChipLeftReversed from '../../../../components/CustomChip/CustomChipLeftReversed';


const required = value => (value ? undefined : 'Required');

const CustomField = props => (
	<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);


class BenefitSelection extends React.Component {
	state = {
		
	};

	

	componentDidMount() {
		this.props.scrollMeBar();

		

		/*let { benefits } = this.state;
		benefits.map(benefit => {
			if (this.props.clientAge) {
				if (this.props.clientAge > benefit.maxAge) {
					benefit.disabled = true;
					benefit.messages.push(
						'Client is too old to qualify for this benefit'
					);
				}
				if (this.props.clientAge < benefit.minAge) {
					benefit.disabled = true;
					benefit.messages.push(
						'Client is too young to qualify for this benefit'
					);
				}
			}
			return benefit;
		});

		if (!this.props.benefitsInitialized && this.props.autoPopulatedBenefits) {
			let editBenefits = this.props.autoPopulatedBenefits
				.split(',')
				.map(t => parseInt(t, 10));
			let autoPopBenefits = [];

			benefits.map(ben => {
				if (editBenefits.includes(ben.id)) {
					autoPopBenefits.push(ben.id);
				}
				return ben;
			});

			this.props.setBenefitsInitialized(autoPopBenefits);
		}

		this.setState({ benefits: benefits });*/
	}
/*
	handleCheck = id => {
		if (this.props.selectedBenefits.find(t => t === id)) {
			this.props.checkSelectedBenefit(id, false);
		} else {
			this.props.checkSelectedBenefit(id, true);
		}
		this.forceUpdate();
	};

	enabledBenefits() {
		const { benefits } = this.state;
		return benefits.filter(benefit => !benefit.disabled);
	}

	checkAll = () => {
		if (this.props.selectedBenefits.length !== this.enabledBenefits().length) {
			this.props.toggleAllBenefits(this.enabledBenefits(), true);
		} else {
			this.props.toggleAllBenefits(this.enabledBenefits(), false);
		}
		this.forceUpdate();
	};
*/
	render() {
		/*const allSelected =
			this.props.selectedBenefits.length === this.enabledBenefits().length;*/
			var gapCoverOptions = [];

			if(this.props.gapCover == 1)
			{
				gapCoverOptions = 
				(
					<Grid container>
							<CustomField
								name={'gapCoverLevel'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Level of Gap Cover'}
								isrequired={true}
								onChange={e => this.props.changeGapLevel(e)}
								//validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: '1', displayValue: '200% - 300%' },
									{ value: '2', displayValue: '301% - 500%' },
									{ value: '3', displayValue: '500% +' },
									
								]}
							/>

							<CustomField
								name={'paymentCover'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Gap + Co-Payment Cover'}
								onChange={e => this.props.changeCoPay(e)}
								isrequired={true}
								//validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: '1', displayValue: 'Yes' },
									{ value: '0', displayValue: 'No' },
									
								]}
							/>
					</Grid>
				)
			}

		return (
			<div className="contentWithStepper">
				<Card className={this.classes}>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Cover Selection"
						/>
						<Grid container>

						<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
						
						</GridItem>
							
								<CustomField
									name={'planType'}
									component={FormDropdown}
									checkValidation={this.props.checkValidation}
									label={'Plan Type'}
									isrequired={true}
									onChange={e => this.props.changePlanType(e)}
									validate={[required]}
									options={[
										{value:" ",  displayValue: 'Please select' },
										{ value: 'capitation', displayValue: 'Capitation' },
										{ value: 'hospital plan', displayValue: 'Hospital plan' },
										{ value: 'hybrid', displayValue: 'Hybrid' },
										{ value: 'new generation', displayValue: 'New generation' },
										{ value: 'threshold', displayValue: 'Threshold' },
										{ value: 'traditional', displayValue: 'Traditional' },
										{ value: 'all', displayValue: 'All' }
									]}
								/>
								
								<CustomField
									name={'coverType'}
									component={FormDropdown}
									checkValidation={this.props.checkValidation}
									label={'Cover Type'}
									isrequired={true}
									onChange={e => this.props.changeCoverLevel(e)}
									validate={[required]}
									options={[
										{value:" ",  displayValue: 'Please select' },
										{ value: 'high', displayValue: 'High' },
										{ value: 'medium', displayValue: 'Medium' },
										{ value: 'low', displayValue: 'Low' },
										{ value: 'all', displayValue: 'All' }
									]}
								/>
									
									<CustomField
								name={'hospitalType'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Hospital preference'}
								isrequired={true}
								onChange={e => this.props.changeHospitalLevel(e)}
								validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: 'state', displayValue: 'State' },
									{ value: 'network', displayValue: 'Network' },
									{ value: 'any', displayValue: 'Any' },
									{ value: 'all', displayValue: 'All' }
								]}
							/>

<CustomField
								name={'serviceType'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Service provider (daty to day)'}
								isrequired={true}
								onChange={e => this.props.changeServiceLevel(e)}
								validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: 'network', displayValue: 'Network' },
									{ value: 'any', displayValue: 'Any' },
									{ value: 'all', displayValue: 'All' }
								]}
							/>

							<CustomField
								name={'chronicType'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Chronic provider'}
								isrequired={true}
								onChange={e => this.props.changeChronicLevel(e)}
								validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: 'state', displayValue: 'State' },
									{ value: 'network', displayValue: 'Network' },
									{ value: 'any', displayValue: 'Any' },
									{ value: 'all', displayValue: 'All' }
								]}
							/>

						
							{
								this.props.state.hSaverOption == 1 &&
								<CustomField
									name={'dayToDay'}
									component={NumberInput}
									checkValidation={this.props.checkValidation}
									label={'How much cover per annum needed for day to day?'}
									isrequired={true}
									onChange={e => this.props.changeDToD(e)}
									validate={[required]}
								/>
							}

							
							<CustomField
								name={'brokerFee'}
								component={NumberInput}
								checkValidation={this.props.checkValidation}
								label={'Broker fee'}
								isrequired={true}
								onChange={e => this.props.changeBrokerFee(e)}
								validate={[required]}
								prefix="R"
								initialValues = {123}
								
							/>

						
							<CustomField
								name={'subsidy'}
								component={NumberInput}
								checkValidation={this.props.checkValidation}
								label={'Monthly Subsidy'}
								isrequired={true}
								onChange={e => this.props.changeSubsidy(e)}
								validate={[required]}
								prefix="R"
								
							/>

						

						</Grid>

						

							

							
						
					</CardContent>
				</Card>

				<Card
					style={{ marginTop: '25px' }}
				>
					<ExpansionPanel defaultExpanded={false} >
						<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
							<Typography
								variant="subheading"
								style={{ fontWeight: 'normal' }}
							>
								Gap Cover
							</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
						<Grid container>
						<GridItem xs={12} sm={12} md={12} style={{ marginTop: '25px' }}>
							<CustomField
									name={'gapCover'}
									component={FormDropdown}
									checkValidation={this.props.checkValidation}
									label={'Include Gap cover'}
									isrequired={true}
									//validate={[required]}
									onChange = {e => this.props.changeGap(e[0])}
									options={[
										{value:" ",  displayValue: 'Please select' },
										{ value: '1', displayValue: 'Yes' },
										{ value: '0', displayValue: 'No' },
										
									]}
								/>	

								</GridItem>
								<GridItem xs={12} sm={12} md={12} style={{ marginTop: '25px' }}>
									{gapCoverOptions}
								</GridItem>
								
						</Grid>
								
							
								
							
						</ExpansionPanelDetails>
					</ExpansionPanel>
				</Card>

				<Card
					style={{ marginTop: '25px' }}
				>
					<ExpansionPanel defaultExpanded={false} >
						<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
							<Typography
								variant="subheading"
								style={{ fontWeight: 'normal' }}
							>
								Loyalty Program
							</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<CustomField
								name={'loyalty'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Add Loyalty Program'}
								isrequired={true}
								onChange = {e => this.props.changeLoyalty(e[0])}
								//validate={[required]}
								options={[
									{value:" ",  displayValue: 'Please select' },
									{ value: '1', displayValue: 'Yes' },
									{ value: '0', displayValue: 'No' },
									
								]}
							/>
						</ExpansionPanelDetails>
					</ExpansionPanel>
				</Card>
			</div>
		);
	}
}

export default BenefitSelection;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/BenefitSelection.jsx